import { addMessages, init, locale } from 'svelte-i18n';
import { LocalStorage } from '@client/utils/local-storage';

import en from './locales/en.json';
import es from './locales/es.json';

const lang = LocalStorage.get('locale');

if (!lang) {
  LocalStorage.update('locale', 'en');
}

// TODO: Future Kieran
// Switch to register() once code-splitting changes are merged
addMessages('en', en);
addMessages('es', es);

init({
  fallbackLocale: 'en',
  initialLocale: lang ?? 'en'
});

locale.subscribe((lang) => LocalStorage.update('locale', lang));
